import React from 'react';
import { makeStyles } from '@mui/styles';
import { observer } from 'mobx-react-lite';

import Icon from './icon.svg';

const useStyles = makeStyles(theme => ({
    icon: {
        marginBottom: 10
    },
    header: {
        textTransform: 'capitalize',
        fontSize: 14,
        fontWeight: 700,
        marginBottom: 5,
        color: theme.palette.grey[900]
    },
    wrapper: {
        color: theme.palette.grey[600],
        fontSize: 12,
        marginTop: 40,
        textAlign: 'center'
    }
}));

const EmptyState = observer(({ header = 'correct answers' }) => {
    const classes = useStyles();

    return (
        <div className={classes.wrapper}>
            <img src={Icon} className={classes.icon} alt="empty" />
            <div className={classes.header}>No {header}</div>
            <div>No {header} have been added<br />for this question</div>
        </div>
    );
});

export default EmptyState;
